import { getExtensionOnly } from 'helpers/validators.helper'
import { multimediaBlockIframeAllowedFiles } from 'helpers/allowedExtensionFiles.helper'
import { BlockMultimediaContent } from 'store/states/lessons.state'
import Img from 'components/ui/Img'
import { useIsMobile } from 'hooks/useIsMobile'
import { MultimediaTypes } from 'enum/multimediaTypes.enum'
import { Video } from './components/Video'
import Pdf from './components/Pdf'
import { DownloadFile } from './components/DownloadFile'

import styles from './ContentByType.module.scss'

interface ContentByTypeProps {
  dataMultimedia: BlockMultimediaContent
  courseId: number
}

export function ContentByType({
  dataMultimedia,
  courseId,
}: ContentByTypeProps) {
  const isMobile = useIsMobile()
  const { fileData, denyDownload } = dataMultimedia
  if (!fileData?.id) return null

  const { url } = dataMultimedia
  const {
    metadata: { filename },
  } = fileData
  const extension = getExtensionOnly(filename)
  if (!extension) return null

  const fileType = multimediaBlockIframeAllowedFiles.find((allowedFile) =>
    allowedFile.extension.includes(extension.toLowerCase())
  )

  switch (fileType?.type) {
    case MultimediaTypes.pdf: {
      if (denyDownload) return <Pdf url={url} denyDownload={denyDownload} />

      if (isMobile) return <DownloadFile dataMultimedia={dataMultimedia} />

      return <Pdf url={url} denyDownload={denyDownload} />
    }
    case MultimediaTypes.ppt: {
      if (isMobile) return <DownloadFile dataMultimedia={dataMultimedia} />

      return (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
            url
          )}`}
          width="100%"
          className={styles.ppt}
        />
      )
    }
    case MultimediaTypes.video:
      return (
        <Video
          id={dataMultimedia.id}
          url={url}
          onMobile={isMobile}
          data={dataMultimedia}
          courseId={courseId}
        />
      )

    case MultimediaTypes.image:
      return (
        <Img
          width="100%"
          src={url}
          imageHandlerProps={{
            width: isMobile ? 800 : 1200,
          }}
        />
      )
    default:
      return <DownloadFile dataMultimedia={dataMultimedia} />
  }
}
